import { useContext } from "react";

import { AuthContext } from "~/auth/AuthProvider";
import { GetMeQuery } from "~/gql/queries/users.generated";
import { useGetMeQuery } from "~/services/endpoints/apiEndpoints";

export type MyUser = NonNullable<GetMeQuery["me"]>;

export interface UseMyUserReturn {
	hasExplicitAssignment: boolean;
	hasUserRecord: boolean;
	isAnswered: boolean;
	isLoading: boolean;
	myUser?: MyUser;
	refetch: () => void;
}

const useMyUser = (): UseMyUserReturn => {
	const { loggedIn } = useContext(AuthContext);
	const { data, isLoading, refetch } = useGetMeQuery(undefined, { skip: !loggedIn });
	const myUser = data?.me ?? undefined;
	const hasExplicitAssignment =
		(myUser?.assignedCustomerIds?.length ?? 0) > 0 || (myUser?.assignedRoutes?.length ?? 0) > 0;

	return {
		hasExplicitAssignment,
		hasUserRecord: data?.me !== null,
		isAnswered: data !== undefined,
		isLoading: loggedIn && isLoading,
		myUser,
		refetch
	};
};

export default useMyUser;
